import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  private breakpointObserver = inject(BreakpointObserver);

  private maxWidthSubject = new BehaviorSubject<string>('(max-width: 768px)');

  isMobile$: Observable<boolean> = this.maxWidthSubject.pipe(
    switchMap((maxWidth) =>
      this.breakpointObserver
        .observe([maxWidth])
        .pipe(map((result) => result.matches)),
    ),
  );

  isMobile = toSignal(this.isMobile$);

  setMaxWidth(maxWidth: string) {
    this.maxWidthSubject.next(maxWidth);
  }
}
